// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25Aav","title":"styles_title__2d_Dy"};